<template>
  <div id="container" v-if="model.id!==undefined">
    <h2 class="text-center">{{model.name}}</h2>
    <div class="padding-10" v-html="model.content"></div>
  </div>
</template>

<script>
import Api from '@/utils/api'
export default {
  created () {
    Api.post('inf.article/model', {id: this.$route.query.id}, res => { this.model = res.data })
  },
  data () {
    return {
      model: {}
    }
  },
  methods: {
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/inf/article/Model.vue